module.exports = __webpack_public_path__ + "2f12a55c9cbc2859016b25d259309580.pdf";